import { createFileRoute } from '@tanstack/react-router';

import { AdminUserArchiveModal } from '~/components/modals/user/AdminUserArchiveModal';
import { USER_ROLES } from '~/features/auth/roles';
import { Route as AbbottAdminUserArchiveListRoute } from '~/routes/abbott-administration/archive';
import { protectedRoute } from '~/utils/routesAuthorization';

const TEST_ID = 'abbott-archive-user-details';

export const Route = createFileRoute('/abbott-administration/archive/$userId')({
  component: ArchiveUserComponent,
  params: {
    parse: (params) => ({ userId: params.userId }),
  },
  beforeLoad: () => {
    protectedRoute({
      roles: [USER_ROLES.AbbottUser, USER_ROLES.AdminAbbott],
    });
  },
});

function ArchiveUserComponent() {
  const { userId } = Route.useParams();

  return (
    <AdminUserArchiveModal
      testID={TEST_ID}
      userId={userId}
      onCloseRedirectPath={AbbottAdminUserArchiveListRoute.fullPath}
    />
  );
}
